<template>
  <v-container fluid>
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-monitor-dashboard
      </v-icon>   Digi-Boards List
    </h2>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <br>
      <v-col
        class="text-right"
      >
        <v-btn
          color="#FF3700"
          @click="createDigiBoard()"
        >
          <v-icon dark>
            mdi-pencil
          </v-icon>
          Create New
        </v-btn>
      </v-col>
      <br>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="4"
          >
            <v-text-field
              v-model="search"
              label="Search"
              append-icon="mdi-magnify"
              outlined
              dense
            />
          </v-col>
          <v-spacer />
          <v-col
            cols="12"
            lg="4"
          >
            <v-autocomplete
              v-model="selectedOrganizationId"
              menu-props="auto"
              :items="organizationList"
              item-value="external_id"
              item-text="name"
              label="Select Organization"
              outlined
              dense
              @input="getDigiBoardsUnderOrganization()"
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="digiBoardsList"
        :search="search"
        class="elevation-1"
      >
        <template #item="{ item }">
          <tr>
            <td>{{ item.external_id }}</td>
            <td>
              <p v-if="item.board_number === null">
                Nil
              </p>
              <p v-else>
                {{ item.board_number }}
              </p>
            </td>
            <td>
              <p>
                <font
                  :color="getColor(item.under_warranty)"
                  class="font-my-style"
                >
                  {{ item.under_warranty | statusUpdate }}
                </font>
              </p>
            </td>
            <td>{{ item.location }}</td>
            <td>{{ item.updated_at | diffHumans }}</td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="#37474F"
                @click.stop
                @click="getDigiBoardContent(item.external_id)"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                color="#37474F"
                x-small
                icon
                @click="editDigiBoard(item.external_id)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="#C62828"
                @click.stop
                @click="deleteDigiBoard()"
              >
                <v-icon>mdi-trash-can</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <br>
      <v-btn
        v-if="!showDigiBoardsList"
        color="red darken-3"
        class="mb-1 ml-1 "
        @click="back()"
      >
        Back
      </v-btn>
      <centre-spinner
        :loading="loading"
      />
      <edit-digi-board
        v-if="showForm"
        :digi-board-id="digiBoardId"
        @closed="showForm = false"
      />
    </v-card>
  </v-container>
</template>

<script>
  import moment from 'moment';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import Constants from 'src/constants';
  import EditDigiBoard from 'src/views/dashboard/digiboards/EditDigiBoard.vue';

  export default {
    name: 'DigiBoardList',
    components: {
      'centre-spinner': spinner,
      'edit-digi-board': EditDigiBoard,
    },
    filters: {
      diffHumans (val) {
        return moment(val).fromNow();
      },
      statusUpdate (warranty) {
        if (warranty === true) return 'Active*';
        else return 'Inactive';
      },
    },
    data () {
      return {
        search: '',
        loading: false,
        selectedOrganizationId: '',
        headers: [
          { text: 'Digi-Board', align: 'start', value: 'external_id' },
          { text: 'Board Number', value: 'board_number' },
          { text: 'Warranty', value: 'under_warranty' },
          { text: 'Location', value: 'location' },
          { text: 'Last Updated', value: 'updated_at' },
          { text: 'More', value: 'more' },
          { text: 'Edit', value: 'edit' },
          { text: 'Delete', value: 'delete' },
        ],
        showForm: false,
        digiBoardId: '',
      };
    },
    computed: {
      digiBoardsList () {
        return this.$store.getters['digiboards/getDigiBoardsList'];
      },
      organizationList () {
        return this.$store.getters['organizations/getOrganizationList'];
      },
      showDigiBoardsList () {
        return this.selectedOrganizationId === '';
      },
    },
    async mounted () {
      this.$store.dispatch('organizations/fetchOrganizationList');
      await this.getDigiBoardsList();
    },
    methods: {
      async getDigiBoardsList () {
        this.loading = true;
        await this.$store.dispatch('digiboards/fetchDigiBoardsList');
        this.loading = false;
      },
      deleteDigiBoard () {
        this.$store.dispatch('alert/onAlert', {
          message: 'Sorry!! Yor are not authorized to delete the digi-boards from the list.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
      },
      createDigiBoard () {
        this.$router.push({ name: 'Create DigiBoards' });
      },
      getColor (warranty) {
        if (warranty === true) return '#2E7D32';
        else return '#C62828';
      },
      async getDigiBoardsUnderOrganization () {
        this.loading = true;
        await this.$store.dispatch('digiboards/fetchDigiBoardsUnderOrganization', {
          params: {
            organizationId: this.selectedOrganizationId,
          },
        });
        this.loading = false;
      },
      back () {
        this.selectedOrganizationId = '';
        this.getDigiBoardsList();
      },
      getDigiBoardContent (externalId) {
        this.$router.push(`/digi-boards/${externalId}`);
      },
      editDigiBoard (externalId) {
        this.showForm = true;
        this.digiBoardId = externalId;
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.v-data-table {
  background-color: #ECEFF1;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.font-my-style {
  font-weight: bold;
}
</style>
